import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getRoleGrants} from 'src/openapi/admin/apis/RoleGrantsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    roleId: string,
    pageNumber: number,
    pageSize: number,
};

export const useRoleGrants = ({roleId, pageNumber, pageSize}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getRoleGrants({roleId, pageNumber, pageSize}, {signal}),
    ), [roleId, pageNumber, pageSize, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {
            roleId: '',
            grants: [],
            totalCount: 0,
        },
        getDispatchAction,
    });
};
